/**
 * @file 應用程式設定
 * @description 定義應用程式的全域設定，包含權限控制、API 端點等
 */

/** 檢查使用者登入狀態控制開關 */
export const CHECK_LOGIN: boolean = true;
/** 頁面 檢查使用者權限 控制開關 */
export const PAGE_CHECK_AUTH: boolean = false;
/** 功能 檢查使用者權限 控制開關 */
export const FUNCTION_CHECK_AUTH: boolean = false;
/** 側邊欄 檢查使用者權限 控制開關 */
export const SIDE_MENU_CHECK_AUTH: boolean = false;
/** 側邊欄預設狀態 true 展開 false 縮小 */
export const SIDE_MENU_IS_OPEN: boolean = false;
/** 預設時區 */
export const DEF_TIME_ZONE: number = 8;

/** 環境設定介面 */
interface Config {
  SERVER_POINT: string;
}

/**
 * 環境變數設定
 * 直接從 Vite 環境變數讀取，不需要額外的 switch 邏輯
 *
 * 設定檔案優先順序 (development mode):
 * 1. .env.development.local (本機開發，不提交 Git)
 * 2. .env.development
 * 3. .env.local
 * 4. .env
 */
const config: Config = {
  SERVER_POINT: import.meta.env.VITE_API_URL || 'http://127.0.0.1:5500/api/'
};

export default config;
